import React from 'react';
import ReactDOM from 'react-dom/client';
// Czcionka z naszego serwera, nie z Google Fonts: pobieranie z fonts.googleapis.com
// przekazywało Google adres IP każdego odwiedzającego, a polityka prywatności
// obiecuje brak podmiotów trzecich poza tymi, które wymienia.
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/700.css';
import './index.css';
// Tłumaczenia muszą być gotowe przed pierwszym renderem (język wynika z kraju w adresie).
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { dotPulse } from 'ldrs'

dotPulse.register();

// Treść, którą backend wstrzyknął do #root (np. strony par /kompatybilnosc/<para>). React
// zaraz ją zastąpi, więc zapamiętujemy ją wcześniej; korzysta z niej pages/KompatybilnoscPara.
const rootEl = document.getElementById('root');
window.__VV_TRESC_SERWERA__ = { sciezka: window.location.pathname, html: rootEl.innerHTML };

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
